export default "__VITE_PUBLIC_ASSET__89d9ec53__"